import { Playlist, PlaylistEntry, VideoEvent } from '@statsbomb/video-client-js';
import { useTrackVideoStart } from '@/analytics/snowplow/hooks/useTrackVideoStart';
import { defaultVideoControls } from '@/consts/video';
import { VideoAuthAndKeyboardWrapper } from '../VideoProvider';
import { UnavailableVideosMessage } from './UnavailableVideosMessage';

export const VideoPlayer = ({
  videoEvents,
  unavailableVideosCount,
}: {
  videoEvents: PlaylistEntry[];
  unavailableVideosCount?: number;
}) => {
  useTrackVideoStart();

  return (
    <VideoAuthAndKeyboardWrapper>
      <VideoEvent autoPlay events={videoEvents} controls={defaultVideoControls} />
      <UnavailableVideosMessage unavailableVideosCount={unavailableVideosCount} />
      <div className="max-h-[300px] md:max-h-[700px] overflow-auto">
        {videoEvents.length > 0 && <Playlist enableEditMode />}
      </div>
    </VideoAuthAndKeyboardWrapper>
  );
};
